import { render, staticRenderFns } from "./Rewardpage.vue?vue&type=template&id=1c4076bc&scoped=true&"
import script from "./Rewardpage.vue?vue&type=script&lang=js&"
export * from "./Rewardpage.vue?vue&type=script&lang=js&"
import style0 from "./Rewardpage.vue?vue&type=style&index=0&id=1c4076bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4076bc",
  null
  
)

export default component.exports